module.exports = __webpack_public_path__ + "static/img/p10.68e2fba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/comic/004/p10.jpg
// module id = 168
// module chunks = 0